import React from "react";
import Reveal from "@/components/Reveal";
import { BlinkingEyes } from "@/components/BlinkingEyes";
import { useLang } from "@/i18n";

const STORY_IMG = "https://images.unsplash.com/photo-1654727317205-c0efb54ceb7e";
const storySrc = (w) => `${STORY_IMG}?auto=format&fit=crop&q=70&w=${w}`;
const STORY_SRCSET = [600, 900, 1200, 1600].map((w) => `${storySrc(w)} ${w}w`).join(", ");

const Story = () => {
  const { t } = useLang();

  return (
    <section id="story" className="bg-[#E6D9B6] py-24 md:py-32 px-6 md:px-12 lg:px-20 scroll-mt-[104px]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-7 order-2 lg:order-1">
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src={storySrc(1200)}
              srcSet={STORY_SRCSET}
              sizes="(max-width: 1024px) 100vw, 58vw"
              alt="Manos recogiendo cerezas de café maduras en la planta"
              loading="lazy"
              decoding="async"
              className="w-full h-[420px] md:h-[560px] object-cover"
            />
          </div>
        </Reveal>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <Reveal>
            <p className="text-[#3B2523]/70 uppercase tracking-[0.25em] text-xs font-semibold mb-6">
              {t.story.tag}
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-[#3B2523] leading-[1.05]">
              {t.story.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-[#3B2523]/80 text-lg mt-7 leading-relaxed">{t.story.p1}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-[#3B2523]/80 text-lg mt-5 leading-relaxed">{t.story.p2}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-[#3B2523]/80 text-lg mt-5 leading-relaxed">{t.story.p3}</p>
          </Reveal>
          <Reveal delay={0.25}>
            <blockquote className="mt-9 border-l-2 border-[#3B2523] pl-6 font-display text-xl md:text-2xl font-semibold text-[#3B2523] leading-snug">
              {t.story.quote}
            </blockquote>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="flex flex-wrap gap-2.5 mt-8">
              {t.story.values.map((v, i) => (
                <span
                  key={i}
                  className="text-sm font-medium text-[#3B2523] border border-[#3B2523]/30 rounded-full px-4 py-1.5"
                >
                  {v}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      <Reveal className="flex justify-center mt-20">
        <BlinkingEyes variant="chocolate" width={74} footer testId="story-mascot-eyes" />
      </Reveal>
    </section>
  );
};

export default Story;
